package br.com.vvrefeicoes.portal.core.ui.layout

import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

object AppBreakpoints {
    val compact = 840.dp
}

@Composable
fun AppResponsiveLayout(
    modifier: Modifier = Modifier,
    breakpoint: Dp = AppBreakpoints.compact,
    content: @Composable (isCompact: Boolean) -> Unit,
) {
    BoxWithConstraints(modifier = modifier) {
        content(maxWidth < breakpoint)
    }
}
